import { environment } from "src/environments/environment";

export class AppSettings {    
     public static API_ENDPOINT = `${environment.baseUrl}`; //'/api';
     public static LOGIN = 'auth/oauth/google/signin';
     public static PVADMINSSOLOGIN = 'auth/portal/sso-login';
     public static GRAFANAURLS = 'dashboard/grafana/urls';
     public static COMPARED = 'site/network/devices/compared/stored/by_ip?siteIp=';
     public static VIEW_SDT = 'sdt/viewSdts?';
     public static SDTPOST = 'sdt/addAllSdt';
     public static SDTUPDATE = 'sdt/update/all';
     public static SDTGET = 'sdt/get/allSdts';
     public static DASHBOARDSITES = 'dashboard/sites/details';
     public static DASHBOARDSITESPAGINATION = 'dashboard/sites/all?page=';
     public static DASHBOARDSITESSORTING = '&sort=id&direction=';//&sort=id&direction=DESC/ASC
     public static DASHBOARDSITESSEARCHING = 'dashboard/sites/all?siteName=';//http://localhost:9050/api/dashboard/sites/all?search=VGSTEST&sort=siteName,asc
     public static DASHBOARDSITESSEARCHASC = '&sort=siteName,asc';
     public static DASHBOARDMONITORS = 'monitors/devices/all';
     public static DASHBOARDMONITORPAGINATION = 'monitors/devices?page=';
     public static DASHBOARDMONITORSBYSTATUS = 'monitors/devices/byStatus?status=';//monitors/devices/byStatus?status=1    
     public static DASHBOARDMONITORSORTING = 'monitors/devices?page='; //monitors/devices?page=0&sort=fieldName,desc/asc
     public static DASHBOARDMONITORSSEARCHING = 'monitors/devices?siteName='; //monitors/devices?siteName=VGSTEST56
     public static GETPRIVILEGE = 'privilege/getAllPrivileges';
     public static GETPRIVILEGEONID = 'privilege/get/'; ///privilege/get/2
     public static ADDPRIVILEGE = 'privilege/add';
     public static EDITPRIVILIGES = 'privilege/update';
     public static DELETEPRIVILIGES = 'privilege/delete';
     public static GETROLES = 'roles/getAllRoles'; //roles/getAllRoles
     public static GETROLEONID = 'roles/'; //roles/:roleId
     public static ADDROLE = 'roles/add';
     public static EDITROLE = 'roles/update';
     public static DELETEROLE = 'roles/delete?roleId='; //roles/delete?roleId=7
     public static ADDUSER = 'user/addUser';
     public static GETUSERS = 'user/getAllUsers';
     public static UPDATEUSER = 'user/update';
     public static DELETEUSER = 'user/delete?userId='; //user/delete?userId=14
     public static METRICS = 'metrics/dashboard/sites';
     public static DEVICEMETRICS = 'metrics/dashboard/devices';
     public static METRICSSTATS = 'metrics/meengine';
     public static X3HEALTHMONITORING = 'x310/stats/info';
     public static X310METRICS = 'metrics/x310';
     public static DEVICE_CSV = '/monitors/devices/export';
     public static SITES_CSV = '/dashboard/sites/export';
     public static AGENT_VERSION = 'site/network/agent/info/all';
     public static TICKETDETAILS = 'zendesk/tickets?';
     public static TICKETHISTORY = 'zendesk/device/tickets?deviceUqId=';
     public static SUBDROPDOWN = 'monitors/devices/subdropdown';
    public static WEATHER = 'weather/site?potentailId=';
    public static CPU_USAGE= 'dashboard/cpu/percentage';
    public static RAM_USAGE = 'dashboard/ram/percentage';
    public static CAMERA_DATA = 'meta/get/camUniqueId?camUniqueId=';
    public static CAMMODELS = 'meta/dashboard/cammodels';
    public static MDC_DEVICES = `x310/mdc/devices-db`;
    public static GET_COMMENTS = 'comments/get/allComments';
    public static ADD_COMMENTS = 'comments/addComments';
    public static UPDATE_COMMENTS = 'comments';
    public static AVG_TIME = 'dashboard/get/average/duration';
    public static MANUAL_SYNC = 'manual/sync/refresh?potentialId=';
    public static MONITORING_HOURS = 'dashboard/monitoringHours?potentialId=';
    public static SCRIPT = 'x310/get/devicescript?potentialId=';
    public static MDC_SCRIPT = 'x310/get/devicemdcscript?potentialId=';
    public static VIEW_TICKET = 'zendesk/view/ticket?ticketId=';
    public static UPLOAD_SCRIPT = 'x310/upload/script?potentialId=';
    public static GENERATE_SCRIPT = 'x310/generate/uiscript?potentialId=';
    public static PRE_POPULATE = 'x310/script/values';
    public static SCRIPT_HISTORY = 'x310/script/history?potentialId=';
    public static LAST_CHANGE = 'x310/script/lastchange?potentialId=';
    public static MDC_PRE_POPULATE = "x310/mdcscript/values";
    public static MDC_UPDATE = "x310/generate/mdcscript?potentialId=";
    public static MDC_UPLOAD = "x310/upload/mdcscript?deviceType=";
    public static UPTIME_CSV = 'dashboard/uptime/download';
    public static DELAY_2HRS = 'x310/script/delayhrs';
    public static ACCOUNTS_HISTORY = 'customer/get/history/configurations';
    public static SUBMIT_ACCOUNTS = 'customer/configuration';
    public static PARENT_ACCOUNTS = 'customer/get/all/site/configs';
    public static ROUTER_INFO = 'routers/get/router?ip=';
    public static X310_SAVED = "x310/get/all/saved/settings";
    public static CAM_INFO_ALL = "axis-motion/cam-info/all";
    public static CAM_INFO_UNIQUE = "axis-motion/cam-info?camUniqueId=";
    public static PM_CREATE = 'planned-down-time';
    public static GET_ALL_PM = 'monitors/devices/all?search=&status=3&deviceType=&type=&page=&sort='
    public static GET_UNQ_PM = 'planned-down-time/site-unit-id';
    public static FORECAST = 'weather/forecast/site?potentailId=';
    public static GET_CAMCONFIG_SITE_DETAILS = 'mengine/admin/site/search';
    public static GET_V2_SITE_DETAILS = 'mengine/admin/masking/site/details';
    public static GET_MASKING_DATA  = 'mengine/admin/masking/getmasking';
    public static UPDATE_SITE_DATA = 'mengine/admin/app/update/site/data';
    public static UPTIME_REPORT = 'uptime/for/all/sites';
    public static SOLAR_SUMMARY = 'x310/mdxscript/info';
    public static ACTIVE_AXIS_CAMDATA = 'axis-motion/cam-info/all';
    public static ROUTER_REPORT = 'report/send/router/info?emailId=';
    public static AXIS_DOWNLOAD = 'axis-motion/cam-info/export';
    public static UPLOAD_CHECK = 'x310/upload/check?ip=';
 }
